import React from 'react';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';

const subtitleColor = theme('mode', {
  light: (props) => props.theme.colors.auroMetalSaurus,
  dark: (props) => props.theme.colors.softMidGrey,
});

const SubtitleWrapper = styled(Box)`
  line-height: 1.4;
  font-weight: 300;
  color: ${subtitleColor};
`;

function Subtitle(props) {
  return <SubtitleWrapper fontSize={1} mb={1} {...props} />;
}

export default Subtitle;
